import urlJoin from 'url-join'

export function buildUrls(workspaceServerBase) {
    return {
        aiTaggingTourStatus: urlJoin(workspaceServerBase, '/workspace/web/user-guide'),
    }
}

export type IUrls = ReturnType<typeof buildUrls>
